import LoggingBase from '../../../../base/loggingbase';

const FA_CLASS_REGULAR ='fal';
const FA_SYMBOL_REGULAR = 'fa-asterisk';
const FA_CLASS_FOCUS ='fal';
const FA_SYMBOL_FOCUS = 'fa-star-christmas';
const FONT_SIZE = '12px';
const SYMBOL_COLOR = '#717171';

/**
 * class XtwSelectionCellInsertionDummyExtension - renders the "insertion star" marker in a
 * selection cell of the insertion-dummy row. It is a plain delegate: the host selection
 * cell ({@link XCellItem}) is passed in and accessed via {@link #host}.
 */
export default class XtwSelectionCellInsertionDummyExtension extends LoggingBase {

	/**
	 * constructs a new instance
	 * @param {*} host the host selection cell (XCellItem)
	 */
	constructor( host ) {
		super( 'widgets.xtw.editing.XtwSelectionCellInsertionDummyExtension' );
		this._host = host;
	}

	/**
	 * @returns {*} the host selection cell
	 */
	get host() {
		return this._host;
	}

	/**
	 * @override
	 */
	doDestroy() {
		this._host = void 0;
		super.doDestroy();
	}

	_addInsertionStar( focused = false ) {
		const host = this.host;
		if ( !host.isRendered ) {
			return false;
		}
		host.removeSelectionArrow();
		const element = host.element;
		element.style.alignItems = "center";
		const insertionStar = this._createStar(!!focused);
		element.appendChild( insertionStar );
		return true;
	}

	addInsertionStar() {
		return this._addInsertionStar( false );
	}

	removeInsertionStar() {
		return this.host.removeSelectionArrow();
	}

	addFocusedInsertionStar() {
		return this._addInsertionStar( true );
	}

	_createStar(focused) {
		const starSpan = window.document.createElement( "span" );
		starSpan.style.marginLeft = "auto";
		starSpan.style.marginRight = "auto";
		starSpan.style.fontSize = FONT_SIZE;
		starSpan.style.color = SYMBOL_COLOR;
		const italicIconPlaceholder = window.document.createElement( "i" );
		italicIconPlaceholder.classList.add( (focused ? FA_CLASS_FOCUS : FA_CLASS_REGULAR), (focused ? FA_SYMBOL_FOCUS : FA_SYMBOL_REGULAR) );
		starSpan.appendChild( italicIconPlaceholder );
		return starSpan;
	}

	get insertionStar() {
		return this._createStar(false);
	}

	get focusedInsertionStar() {
		return this._createStar(true);
	}

}
